
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[rootKey]/partnerships",
      function () {
        return require("private-next-pages/[rootKey]/partnerships/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[rootKey]/partnerships"])
      });
    }
  